import { baseColors } from "@Constants/baseStyles"
import * as React from "react"
import Svg, { Path } from "react-native-svg"

function SvgVideoCall(props) {
    return (
        <Svg width={54} height={54} viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <Path
                d="M41.854 38.555a7.44 7.44 0 01-.236-2.56l.421-3.975c.206-2.494-.174-4.992-1.278-7.238-2.852-5.802-2.198-6.223-2.286-11.981a2.13 2.13 0 00-4.26 0c0 23.417.043 21.699-.101 22.385v3.067a4.69 4.69 0 01-4.686 4.685h-11.66a16.544 16.544 0 007.14 5.645c2.196.928 4.65 2.78 5.06 5.078l.04.164a25.754 25.754 0 0014.961-7.098l-3.115-8.172zM9.857 10.745l-.648-.6a2.486 2.486 0 00-3.504.133c-.926 1-.866 2.576.134 3.503l4.018 3.723v-6.759z"
                fill="#FDCFAA"
            />
            <Path
                d="M7.157 11.918a2.48 2.48 0 01-.767-2.156c-.25.128-.483.298-.685.516-.926 1-.866 2.576.134 3.503l4.018 3.723V14.42l-2.7-2.501z"
                fill="#FDCFAA"
            />
            <Path
                d="M42.048 39.065c-.88 6.067-6.102 10.728-12.413 10.728-1.09 0-2.146-.14-3.154-.4 1.67 1.021 3.174 2.514 3.487 4.268l.04.164a25.754 25.754 0 0014.961-7.098l-2.921-7.662z"
                fill={baseColors.orange.primary}
            />
            <Path
                d="M30.545 43.04h-17.11a3.674 3.674 0 01-3.67-3.67V3.67A3.674 3.674 0 0113.435 0h17.11a3.674 3.674 0 013.67 3.67v35.7a3.674 3.674 0 01-3.67 3.67z"
                fill={baseColors.black}
            />
            <Path
                d="M13.434 0a3.674 3.674 0 00-3.669 3.67v35.7a3.674 3.674 0 003.67 3.67h5.1c-1.132-1.156.189-2.284.189-2.284-1.864-.489-1.705-2.447-1.705-2.447V6.511c0-1.872 1.901-2.345 1.901-2.345-.749-.75 0-1.536 0-1.536V1.36C18.23.923 18.365.327 18.516 0h-5.081z"
                fill={baseColors.black}
            />
            <Path
                d="M19.287 2.63h-.367a.634.634 0 010-1.269h.367a.634.634 0 110 1.269zM24.972 2.63h-3.52a.634.634 0 110-1.269h3.52a.634.634 0 010 1.269z"
                fill="#E6F4F4"
            />
            <Path
                d="M30.545 2.283h-2.572a.868.868 0 00-.867.868c0 .558-.457 1.015-1.015 1.015h-8.202a1.018 1.018 0 01-1.015-1.015.868.868 0 00-.868-.868h-2.572c-.765 0-1.386.62-1.386 1.386v35.7c0 .766.62 1.387 1.386 1.387h17.111c.766 0 1.387-.62 1.387-1.386V3.67c0-.766-.621-1.387-1.387-1.387z"
                fill="#E6F4F4"
            />
            <Path
                d="M20.445 40.756V8.69C17.41 7.555 18.92 4.167 18.92 4.166H17.89a1.018 1.018 0 01-1.015-1.015.868.868 0 00-.868-.868h-2.572c-.765 0-1.386.62-1.386 1.387v35.7c0 .766.62 1.386 1.386 1.386h7.01z"
                fill="#E6F4F4"
            />
            <Path
                d="M27.338 17.938c.013.697-.056 1.411-.13 1.887-.352 1.55-.86 2.901-1.51 4.013a5.97 5.97 0 01-1.093 1.362l-.055.051v.348c0 .36.14.693.378 1a12.68 12.68 0 003.36-.66c1.076-.37 1.547-1.645.96-2.619-1.384-2.293-1.178-5.383-1.178-5.383h-.732z"
                fill={baseColors.black}
            />
            <Path
                d="M29.247 23.32a6.539 6.539 0 01-.348-.663c-1.61.934-2.254-.39-2.254-.39s-.042-.06-.118-.174c-.243.633-.52 1.216-.829 1.745a5.97 5.97 0 01-1.092 1.362l-.056.051v.348c0 .36.14.692.378.999 1.334-.08 2.467-.35 3.36-.658 1.076-.37 1.547-1.646.96-2.62zM15.694 25.94a12.68 12.68 0 003.36.658c.239-.306.379-.64.379-1v-.426l-.053-.05a5.974 5.974 0 01-1.009-1.284c-.65-1.113-1.158-2.462-1.51-4.011a10.724 10.724 0 01-.13-1.89h-.818s.206 3.09-1.178 5.383c-.587.974-.116 2.25.959 2.62z"
                fill={baseColors.black}
            />
            <Path
                d="M16.54 28.292c.966 1.651 2.427 2.936 4.227 3.715.806.348 1.73.348 2.536 0 1.8-.779 3.262-2.063 4.227-3.715.037-.063.073-.127.109-.192-1.514-.583-2.917-1.413-2.917-2.498v-.512c-.662.592-1.797 1.346-2.732 1.369-.935-.023-2.07-.777-2.732-1.369 0 .706.187 1.556-2.031 2.633-.256.124-.53.241-.81.35.04.074.081.147.123.219z"
                fill="#FDCFAA"
            />
            <Path
                d="M22.159 26.447c-.057.006-.114.01-.17.012-.934-.023-2.07-.777-2.731-1.369 0 .706.187 1.555-2.031 2.632-.256.125-.53.242-.81.351.04.074.082.147.123.219a8.859 8.859 0 002.462 2.71c.46-.253 1.022-.57 1.682-1.088 1.2-.942 1.465-2.4 1.474-3.467z"
                fill="#FDCFAA"
            />
            <Path
                d="M13.435 40.756h17.11c.766 0 1.387-.62 1.387-1.386V29.304a5.003 5.003 0 00-.62-.162c-.207-.056-2.173-.43-3.904-1.133a14 14 0 01-.152.268c-.917 1.57-2.306 2.79-4.017 3.53a3.048 3.048 0 01-2.411 0c-1.711-.74-3.1-1.96-4.018-3.53a14.506 14.506 0 01-.167-.294c-1.774.731-3.965 1.156-3.974 1.159-.17.032-.382.083-.62.162V39.37c0 .765.62 1.386 1.386 1.386z"
                fill={baseColors.orange.primary}
            />
            <Path
                d="M18.724 40.756c-1.209-.193-1.23-1.112-1.23-1.112v-6.487c0-1.439.587-1.636 1.709-2.266a8.42 8.42 0 01-2.393-2.614 14.506 14.506 0 01-.167-.294c-1.774.731-3.965 1.156-3.974 1.159-.17.032-.382.083-.62.162V39.37c0 .765.62 1.386 1.386 1.386h5.289z"
                fill={baseColors.orange.primary}
            />
            <Path d="M22.033 38.175a3.465 3.465 0 100-6.93 3.465 3.465 0 000 6.93z" fill="#E6F4F4" />
            <Path
                d="M13.465 23.82c-.815.88-2.19.932-3.07.116l-3.638-3.37a2.172 2.172 0 012.953-3.187l3.638 3.37c.88.816.932 2.19.117 3.07z"
                fill="#FDCFAA"
            />
            <Path
                d="M11.892 22.404l-3.638-3.371a2.171 2.171 0 01-.624-2.145 2.172 2.172 0 00-.872 3.678l3.637 3.37a2.172 2.172 0 003.577-1.041c-.707.204-1.5.046-2.08-.491zM13.465 35.669c-.815.88-2.19.932-3.07.117l-3.638-3.372a2.172 2.172 0 112.953-3.186l3.638 3.371c.88.815.932 2.19.117 3.07z"
                fill="#FDCFAA"
            />
            <Path
                d="M11.892 34.253l-3.638-3.37a2.171 2.171 0 01-.624-2.146 2.172 2.172 0 00-.872 3.677l3.637 3.372a2.172 2.172 0 003.577-1.042c-.707.204-1.5.046-2.08-.49zM13.465 29.744c-.815.88-2.19.932-3.07.117L6.757 26.49a2.172 2.172 0 112.953-3.187l3.638 3.371c.88.816.932 2.19.117 3.07z"
                fill="#FDCFAA"
            />
            <Path
                d="M11.892 28.328l-3.638-3.37a2.171 2.171 0 01-.624-2.146 2.172 2.172 0 00-.872 3.677l3.637 3.372a2.172 2.172 0 003.577-1.042c-.707.204-1.5.046-2.08-.49z"
                fill="#FDCFAA"
            />
            <Path
                d="M25.159 9.034c-.83-.428-1.86-.725-3.124-.725-1.265 0-2.296.297-3.125.725a5.404 5.404 0 00-2.933 4.8v2.476c.287-.006.603.087.807.223a1.65 1.65 0 01.318-.615.795.795 0 00.209-.502c.021-.715.209-2.403 1.466-3.05a.74.74 0 01.976.3c.758 1.313 2.525 3.044 6.456 2.306a.463.463 0 01.55.44v.003a.796.796 0 00.209.503c.139.157.242.37.317.615.204-.136.52-.23.806-.223v-2.475a5.404 5.404 0 00-2.932-4.801z"
                fill={baseColors.black}
            />
            <Path
                d="M21.959 14.531c-1.948-3.721 1.712-6.04 1.712-6.04a7.232 7.232 0 00-1.636-.182c-1.265 0-2.296.297-3.125.725a5.404 5.404 0 00-2.933 4.8v2.476c.287-.006.603.087.807.223a1.65 1.65 0 01.318-.615.794.794 0 00.209-.502c.021-.715.209-2.403 1.466-3.05a.74.74 0 01.976.3 4.762 4.762 0 002.297 2.04l-.091-.175z"
                fill={baseColors.black}
            />
            <Path
                d="M16.735 19.85s-.329-2.079.05-3.317c-.344-.229-1.007-.34-1.306-.049-.61.597-.163 1.5.051 2.069.066.175.109.351.128.529.041.385.25.948 1.116.935l-.04-.166zM28.59 16.484c-.299-.291-.962-.18-1.305.05.378 1.238.05 3.317.05 3.317l-.04.166c.866.014 1.075-.55 1.117-.935a2.16 2.16 0 01.127-.53c.214-.569.662-1.47.05-2.068z"
                fill="#FDCFAA"
            />
            <Path
                d="M26.802 15.414a5.7 5.7 0 00-.02-.323.59.59 0 00-.597-.245c-3.748.703-5.505-.833-6.32-2.245a.879.879 0 00-.68-.439 2.2 2.2 0 00-.636.289c-1.099.731-1.262 2.316-1.282 2.963a.747.747 0 01-.198.475c-.688.775-.537 3.04-.377 3.971.356 1.569.87 2.936 1.53 4.065a6.225 6.225 0 002.932 2.578c.56.242 1.201.242 1.76 0a6.225 6.225 0 002.933-2.578c.66-1.128 1.174-2.496 1.53-4.067.154-.98.319-3.185-.377-3.969a.748.748 0 01-.198-.475z"
                fill="#FDCFAA"
            />
            <Path
                d="M22.819 23.925c-.66-1.129-1.175-2.496-1.53-4.065-.16-.932-.311-3.196.377-3.971a.746.746 0 00.198-.475 5.82 5.82 0 01.095-.883 4.622 4.622 0 01-2.094-1.93.879.879 0 00-.68-.44c-.231.065-.444.161-.636.29-1.099.73-1.262 2.316-1.282 2.963a.748.748 0 01-.198.475c-.688.775-.537 3.039-.377 3.971.356 1.569.87 2.936 1.53 4.065a6.226 6.226 0 002.932 2.578c.56.241 1.201.241 1.76 0 .516-.224.99-.507 1.419-.843a6.139 6.139 0 01-1.514-1.735z"
                fill="#FDCFAA"
            />
            <Path
                d="M23.678 37.76c-1.744-.353-1.355-2.112-1.355-2.112s.242-1.559-.9-2.32c-.895-.597-.618-1.535-.455-1.915a3.466 3.466 0 102.71 6.348z"
                fill="#E6F4F4"
            />
            <Path
                d="M23.403 34.378l-1.786-1.002a.381.381 0 00-.568.333v2.002c0 .292.314.476.568.333l1.786-1.001a.381.381 0 000-.665z"
                fill={baseColors.green.primary}
            />
        </Svg>
    )
}

export default SvgVideoCall
